import React, { useContext, useState, useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import { Context } from '../../../index';
import './ClientSwitcher.css';

const ClientSwitcher = observer(() => {
  const { user } = useContext(Context);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (!wrapRef.current?.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  // Сотрудникам этот переключатель не нужен — они не привязаны к клиентам
  if (user.isStaff) return null;

  const clients = user.clients || [];
  const active = user.activeClient;

  if (clients.length === 0) {
    return (
      <div className="cs-empty">
        <ApartmentOutlinedIcon sx={{ fontSize: 18 }} />
        <span>Клиенты не привязаны</span>
      </div>
    );
  }

  if (clients.length === 1) {
    return (
      <div className="cs-single" title={clients[0].name}>
        <ApartmentOutlinedIcon sx={{ fontSize: 18 }} />
        <span className="cs-single__name">{clients[0].name}</span>
      </div>
    );
  }

  const pick = (c) => {
    user.setActiveClient(c);
    setOpen(false);
  };

  const allActive = !active;

  return (
    <div className="cs" ref={wrapRef}>
      <button
        type="button"
        className={`cs__button ${open ? 'cs__button--open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <ApartmentOutlinedIcon sx={{ fontSize: 18 }} className="cs__icon" />
        <span className="cs__current">{active?.name || 'Все мои организации'}</span>
        <KeyboardArrowDownOutlinedIcon sx={{ fontSize: 18 }} className="cs__chev" />
      </button>
      {open && (
        <ul className="cs__menu" role="listbox">
          <li
            role="option"
            aria-selected={allActive}
            className={`cs__option cs__option--all ${allActive ? 'cs__option--active' : ''}`}
            onClick={() => pick(null)}
          >
            <span className="cs__option-name">Все мои организации</span>
            {allActive && <CheckOutlinedIcon sx={{ fontSize: 16 }} />}
          </li>
          {clients.map((c) => {
            const isActive = String(c.id) === String(active?.id);
            return (
              <li
                key={c.id}
                role="option"
                aria-selected={isActive}
                className={`cs__option ${isActive ? 'cs__option--active' : ''}`}
                onClick={() => pick(c)}
              >
                <span className="cs__option-name">{c.name}</span>
                {isActive && <CheckOutlinedIcon sx={{ fontSize: 16 }} />}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
});

export default ClientSwitcher;
